<template lang="pug">
  modal(
    :title='modalProps.type === "resource" ? $t("krea.deleteModal.titleResource") : $t("krea.deleteModal.titleContent")'
    @closeModal='closeModal'
  )
    .column.m-top-2
      k-select.m-bottom-2(
        v-if='availableLanguages.length > 1'
        :label='modalProps.type === "resource" ? $t("krea.deleteModal.deleteResourceDescription") : $t("krea.deleteModal.deleteContentDescription")'
        name="selectedLanguage"
        :placeholder='$t("krea.deleteModal.deletePlaceholder")'
        :options='availableLanguages'
        withBorder
        @selectOption='editSelectedLanguage'
      )
      text-input(
        name="confirm"
        italicPlaceholder
        :value='confirm'
        :updateMethod='updateConfirm'
        :validations='$v.confirm'
        :errorMessage='$t("krea.deleteModal.confirmError")'
        :label='modalProps.type === "resource" ? $t("krea.deleteModal.confirmResource") : $t("krea.deleteModal.confirmContent")'
        :placeholder='confirmExpected'
      )
      .row.middle.end.m-top-2
        button.secondary-button.m-right-2(@click='closeModal') {{ $t("krea.deleteModal.cancel") }}
        button.primary-button(@click='handleDelete') {{ $t("krea.deleteModal.delete") }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Modal from '@/components/Modal'
import KSelect from '@/components/KSelect'
import { supportedLanguages } from '../../constants/languages'
import TextInput from '../Inputs/TextInput'
import { required, sameAs } from 'vuelidate/lib/validators'
import { i18n } from '../../main'

export default {
  components: { Modal, KSelect, TextInput },
  data() {
    return {
      selectedLanguage: null,
      published: false,
      allLanguages: 1,
      confirm: ''
    }
  },
  computed: {
    ...mapState({
      modalProps: state => state.behavior.kreaDeleteModal.props
    }),
    confirmExpected() {
      return this.modalProps.type === 'resource'
        ? i18n.t('krea.deleteModal.confirmResourceValue')
        : i18n.t('krea.deleteModal.confirmContentValue')
    },
    availableLanguages() {
      return this.modalProps.languages.length > 1
        ? [
          { id: this.allLanguages, label: `<div class='row'><p class='text-normal'>Todos los idiomas</p></div>` },
          ...supportedLanguages
            .filter(lang => this.modalProps.languages.includes(lang.lang))
            .map(item => ({
              ...item,
              id: item.lang,
              label: `<div class='row'><img class='m4-right-2' src='${item.icon}'/><p class='text-normal'>${item.label}</p></div>`
            }))
        ]
        : supportedLanguages
          .filter(lang => this.modalProps.languages.includes(lang.lang))
          .map(item => ({
            ...item,
            id: item.lang,
            label: `<div class='row'><img class='m4-right-2' src='${item.icon}'/><p class='text-normal'>${item.label}</p></div>`
          }))
    }
  },
  methods: {
    ...mapActions([
      'hideElement',
      'setKreaEducationalContentKeywords',
      'deleteKreaResource',
      'deleteKreaEducationalContent'
    ]),
    closeModal() {
      this.hideElement({ element: 'kreaDeleteModal' })
    },
    updateConfirm(value) {
      this.confirm = value
    },
    editSelectedLanguage(name, value) {
      this.selectedLanguage = value
    },
    async handleDelete() {
      this.$v.$touch()
      if (this.$v.$invalid) return
      if (this.modalProps.type === 'resource') {
        const success = await this.deleteKreaResource({
          id: this.modalProps.id,
          locale: this.selectedLanguage === this.allLanguages ? null : this.selectedLanguage
        })
        if (success) {
          this.$emit('deletedLanguage')
          this.closeModal()
        }
      }
      if (this.modalProps.type === 'content') {
        const success = await this.deleteKreaEducationalContent({
          id: this.modalProps.id,
          locale: this.selectedLanguage === this.allLanguages ? null : this.selectedLanguage
        })
        if (success) {
          this.$emit('deletedLanguage')
          this.closeModal()
        }
      }
    }
  },
  validations() {
    return {
      selectedLanguage: this.availableLanguages.length > 1 ? { required } : {},
      confirm: { required, sameAsConfirm: sameAs(() => this.confirmExpected) }
    }
  }
}
</script>

<style lang="scss">
@import 'src/scss/variables/colors';

.ti-tag{
  &.keyword{
    background-color: $blue !important;
    span{
      color: $white;
    }
    .ti-icon-close {
      color: $white;
      margin-left: 5px;
    }
  }
}
</style>
